import React from "react";
import { Link } from "react-router-dom";
import {
  Drawer,
  useTheme,
  withStyles,
  WithStyles,
  useMediaQuery,
} from "@material-ui/core";

import { styles } from "./DrawerStyles";
import vediDrawer from "../../../assets/images/iconoDrawer.svg";
import NavigationItems from "./NavigationItems/NavigationItems";
import User from "./User/User";
import ModoAdultoMayor from "./ModoAdultoMayor/ModoAdultoMayor";

interface OwnProps {
  handleDrawerToggle: () => void;
  mobileOpen: boolean;
}
type PublicProps = OwnProps;
type Props = PublicProps & WithStyles<typeof styles>;

const MyDrawer: React.FC<Props> = (props) => {
  const { classes, handleDrawerToggle, mobileOpen } = props;
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));
  const drawer = (
    <div>
      <div className={classes.toolbar}>
        <Link
          to="/servicios"
          onClick={isSmallDevice ? handleDrawerToggle : () => {}}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img src={vediDrawer} alt="Logo de VeDi" width="70%" height="70%" />
        </Link>
      </div>
      <User
        handleDrawerToggle={isSmallDevice ? handleDrawerToggle : () => {}}
      />
      <ModoAdultoMayor />
      <NavigationItems
        handleDrawerToggle={isSmallDevice ? handleDrawerToggle : () => {}}
      />
    </div>
  );

  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      {isSmallDevice ? (
        <Drawer
          // container={container}
          variant="temporary"
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>
      ) : (
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          {drawer}
        </Drawer>
      )}
    </nav>
  );
};

export default withStyles(styles)(MyDrawer) as React.ComponentType<PublicProps>;
